
import { ResponseMapperType, TokenResponseMapper } from './api/types'
import { createQuickWebToken } from './api/quickWebToken'
import { redirectToWestpac } from './helpers/redirectToWestpac'

const resolveFunctionReturnString = async (
    returnValue: string | (() => Promise<string> | string)
): Promise<string> => {
    return typeof returnValue === 'function' ? await returnValue() : returnValue;
};


export interface QuickWebCreditCardPaymentButtonParameters {
    quickWebTokenHandlerEndpoint: string;
    formUrl: string;
    communityCode: string;
    customerReferenceNumber: string;
    returnUrl: string | (() => Promise<string> | string);
    cancelUrl: string | (() => Promise<string> | string);
    supplierBusinessCode: string | (() => Promise<string> | string);
    partner: string;
    requestHeaders: HeadersInit | string;
    principalAmount: number;
    paymentReference: string | (() => Promise<string> | string);
    responseMapper?: TokenResponseMapper;
    mapResponseType?: ResponseMapperType | string;
    onBeforePaymentSubmit?: Function
}

export const quickWebCreditCardPaymentButton = async ({
    quickWebTokenHandlerEndpoint,
    formUrl,
    communityCode,
    customerReferenceNumber,
    returnUrl,
    cancelUrl,
    supplierBusinessCode,
    partner,
    responseMapper,
    principalAmount,
    paymentReference,
    mapResponseType,
    requestHeaders,
    onBeforePaymentSubmit
}: QuickWebCreditCardPaymentButtonParameters) => {

    const resolvedPaymentReference = await resolveFunctionReturnString(paymentReference);
    const resolvedReturnUrl = await resolveFunctionReturnString(returnUrl);
    const resolvedCancelUrl = await resolveFunctionReturnString(cancelUrl);
    const resolvedSupplierBusinessCode = await resolveFunctionReturnString(supplierBusinessCode);
    
    if (resolvedReturnUrl && resolvedCancelUrl && resolvedSupplierBusinessCode) {

        const quickWebTokenApi = createQuickWebToken({
            quickWebTokenHandlerEndpoint,
            responseMapper,
            mapResponseType,
            requestHeaders,
            onBeforePaymentSubmit
        });

        const { token } = await quickWebTokenApi.generateToken({
            customerReferenceNumber,
            principalAmount,
            paymentReference: resolvedPaymentReference,
            returnUrl: resolvedReturnUrl,
            cancelUrl: resolvedCancelUrl,
            supplierBusinessCode: resolvedSupplierBusinessCode,
            partner
        });

        redirectToWestpac({
            token,
            formUrl,
            communityCode,
            customerReferenceNumber: customerReferenceNumber
        });
    }
    else {
        const requiredParams = {
            ReturnUrl: resolvedReturnUrl,
            CancelUrl: resolvedCancelUrl,
            SupplierBusinessCode: resolvedSupplierBusinessCode
        };

        const emptyParams = Object.entries(requiredParams)
            .filter(([_, value]) => !value) 
            .map(([key]) => key);

        if (emptyParams.length > 0) {
            console.error(`${emptyParams.join(', ')} cannot be empty`);
        }
    }
};

